import { render } from "./EspaceAquasensorielResume.vue?vue&type=template&id=2b1a3836"
import script from "./EspaceAquasensorielResume.vue?vue&type=script&lang=js"
export * from "./EspaceAquasensorielResume.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__